export type FxExperiment = {
    experimentId: string;
    variationId: string;
};

export const fxFlagCookie = (flagKey: string) => `fx-${flagKey}`;

export const fxExperimentCookie = (flagKey: string) => `fx-exp-${flagKey}`;

export const formatFxExperiment = ({ experimentId, variationId }: FxExperiment) => `${experimentId}.${variationId}`;

export function parseFxExperiment(value: string | undefined): FxExperiment | null {
    const [experimentId, variationId] = value?.split(".") ?? [];

    return experimentId && variationId ? { experimentId, variationId } : null;
}

export function parseFxFlagValue(value: string | undefined): boolean | string | undefined {
    if (!value) return undefined;
    if (value === "true") return true;
    if (value === "false") return false;

    return value;
}
